/**
 * Share Link Component
 * Accessible copy-to-clipboard functionality with visual feedback
 */

(function() {
    'use strict';

    const FEEDBACK_DURATION = 2000; // ms

    /**
     * Initialize all share link buttons on the page
     */
    function initShareLinks() {
        const buttons = document.querySelectorAll('.share-link__button[data-share-url]');
        
        buttons.forEach(button => {
            button.addEventListener('click', handleShareClick);
            
            // Keyboard support (Enter/Space already handled by button)
            button.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleShareClick.call(button, e);
                }
            });
        });
    }

    /**
     * Handle click on share button
     */
    async function handleShareClick(e) {
        const button = e.currentTarget;
        const url = button.dataset.shareUrl;
        
        if (!url) return;
        
        // Prevent double-clicks during animation
        if (button.classList.contains('share-link__button--copied')) {
            return;
        }

        try {
            await copyToClipboard(url);
            showFeedback(button, true);
        } catch (err) {
            console.error('Failed to copy URL:', err);
            showFeedback(button, false);
        }
    }

    /**
     * Copy text to clipboard using modern API with fallback
     */
    async function copyToClipboard(text) {
        // Modern Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            return navigator.clipboard.writeText(text);
        }
        
        // Fallback for older browsers
        return new Promise((resolve, reject) => {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;';
            textArea.setAttribute('readonly', '');
            textArea.setAttribute('aria-hidden', 'true');
            
            document.body.appendChild(textArea);
            textArea.select();
            textArea.setSelectionRange(0, text.length);
            
            try {
                const success = document.execCommand('copy');
                document.body.removeChild(textArea);
                
                if (success) {
                    resolve();
                } else {
                    reject(new Error('execCommand copy failed'));
                }
            } catch (err) {
                document.body.removeChild(textArea);
                reject(err);
            }
        });
    }

    /**
     * Show visual feedback after copy attempt
     */
    function showFeedback(button, success) {
        const stateClass = success ? 'share-link__button--copied' : 'share-link__button--error';
        
        button.classList.add(stateClass);
        
        // Remove feedback after duration
        setTimeout(() => {
            button.classList.remove(stateClass);
        }, FEEDBACK_DURATION);
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initShareLinks);
    } else {
        initShareLinks();
    }
})();
